<template>
  <base-index
    ref="baseIndex"
    :columns="columns"
    :resourceName="resourceName"
    :pk="pk"
    :disabledFilterButton="true"
    :breadcrumbs="breadcrumbs"
    :disabledAddButton="true"
    :disabledCheckbox="true"
  >
  </base-index>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      resourceName: "message",
      pk: "message_id",
      columns: [
        {
          value: "user_id",
          text: "ユーザーID",
          filter: true,
          width: '50px'
        },
        {
          value: "name",
          text: "ユーザー名",
          filter: true
        },
        {
          value: "latest_message",
          text: "最新メッセージ",
          filter: false,
          width: '50%',
          sorter: false
        },
        {
          value: "updated_at",
          text: "最新メッセージ送信日時",
          type: "date",
          filter: true
        },
        {
          value: "last_checked",
          text: "未読状態",
          filter: true
        },
        {
          value: "user_status",
          text: "削除ステータス",
          filter: true
        }
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "メッセージ一覧",
          disabled: true
        }
      ];
    }
  }
};
</script>
